exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gap-2 {\n  gap: 4px;\n}\n.btn-custom-ctp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  border-radius: 8px !important;\n  height: calc(1.5em + 0.75rem + 2px);\n  font-size: 11px;\n}\n", ""]);

// exports
